/**
 * Helpers for resolving which session status banner a player should see.
 */

export function isPlayerInMatchTeams(match, playerId) {
  if (!match || !playerId) return false;
  return [...(match.team1 || []), ...(match.team2 || [])].includes(playerId);
}

/**
 * @returns {{ index: number, match: object } | null}
 */
export function findPlayerActiveCourt(courtAssignments, playerId) {
  if (!playerId || !courtAssignments?.length) return null;
  for (let index = 0; index < courtAssignments.length; index += 1) {
    const match = courtAssignments[index];
    if (isPlayerInMatchTeams(match, playerId)) {
      return { index, match };
    }
  }
  return null;
}

/**
 * Earliest upcoming slot containing the player (scans all queue slots).
 * @returns {{ index: number, match: object } | null}
 */
export function findPlayerUpcomingSlot(nextAssignments, playerId) {
  if (!playerId || !nextAssignments?.length) return null;
  for (let index = 0; index < nextAssignments.length; index += 1) {
    const match = nextAssignments[index];
    if (isPlayerInMatchTeams(match, playerId)) {
      return { index, match };
    }
  }
  return null;
}

/**
 * @returns {'on_court'|'upcoming'|'to_pick'|'waiting'|'hidden'}
 */
export function resolvePlayerBannerKind({
  viewerPlayerId,
  courtAssignments,
  nextAssignments,
  waitingList,
  pegBoardPickerId = null,
}) {
  if (!viewerPlayerId) return 'hidden';
  if (findPlayerActiveCourt(courtAssignments, viewerPlayerId)) return 'on_court';
  if (findPlayerUpcomingSlot(nextAssignments, viewerPlayerId)) return 'upcoming';
  if (pegBoardPickerId && viewerPlayerId === pegBoardPickerId) return 'to_pick';
  if (waitingList?.includes(viewerPlayerId)) return 'waiting';
  return 'hidden';
}

/**
 * @param {number} upcomingIndex — 0-based slot in the upcoming queue
 */
export function getPlayerUpcomingBannerCopy(upcomingIndex) {
  if (upcomingIndex <= 0) {
    return { title: "You're up next", subtitle: 'Your match' };
  }
  const gamesAhead = upcomingIndex;
  const aheadLabel = gamesAhead === 1 ? '1 game ahead' : `${gamesAhead} games ahead`;
  return { title: "You're on court soon", subtitle: aheadLabel };
}
